export enum QuestionaryPhase {
  INSTRUCTIONS = 'instructions',
  QUESTIONS = 'questions',
  RESULTS = 'results',
  REWARDS = 'rewards'
}

